import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterProjects: [
    "Scoreboard",
    "Flight Booking",
    "Product Cart",
    "Book Store",
    "Product Cart",
    "Book Store",
    "Blog Application",
    "Job Finder",
  ],
};

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    addTofilterProjects: (state, action) => {
      state.filterProjects.push(action.payload);
    },
    removeFromFilterProject: (state, action) => {
      state.filterProjects = state.filterProjects.filter(
        (project) => project !== action.payload
      );
    },
  },
});

export default projectsSlice.reducer;
export const { addTofilterProjects, removeFromFilterProject } =
  projectsSlice.actions;
